<svg
  style="fill: white"
  height="24"
  viewBox="0 0 21 24"
  width="21"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.08594 11.4857L6.94308 9.34287L6.08594 10.1143L9.08594 13.1143L14.4859 7.7143L13.6288 6.94287L9.08594 11.4857Z"
    fill-opacity="0.75"
  />
  <path
    d="M18 16.6286V10.4571C18 6.68571 15.8571 3.51429 12.1714 2.65714V1.8C12.2571 0.857143 11.3143 0 10.2857 0C9.25714 0 8.4 0.857143
    8.4 1.88571V2.74286C4.62857 3.51429 2.57143 6.68571 2.57143 10.4571V16.6286L0 19.1143V20.3143H20.5714V19.1143L18 16.6286ZM10.2857
    16.1143C6.94286 16.1143 4.28571 13.4571 4.28571 10.1143C4.28571 6.77143 6.94286 4.11429 10.2857 4.11429C13.6286 4.11429 16.2857
    6.77143 16.2857 10.1143C16.2857 13.4571 13.6286 16.1143 10.2857 16.1143Z"
    fill-opacity="0.75"
  />
  <path
    d="M10.2858 24.0001C11.7429 24.0001 12.8572 22.8858 12.8572 21.5144H7.71436C7.71436 22.8858 8.82864 24.0001 10.2858 24.0001Z"
    fill-opacity="0.75"
  />
</svg>
